"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _colors = require("../../../theme/colors");

var _ref = _react["default"].createElement(_Close["default"], {
  color: "secondary",
  fontSize: "small"
});

var ClearIndicator = function ClearIndicator(props) {
  // eslint-disable-next-line react/prop-types
  var isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      selectProps = props.selectProps; //   const iconStyle = {
  //     cursor: 'pointer',
  //     height: 24,
  //     width: 24,
  //   };

  return _react["default"].createElement(_reactSelect.components.ClearIndicator, props, _ref);
};

var _default = ClearIndicator;
exports["default"] = _default;